import * as React from "react";
import { StyleSheet } from "react-native";
import { Feather } from "@expo/vector-icons";
import Colors from "../../../../../constants/Colors";
import { Input, View, Text } from "../../../../../components/Themed";
import { useFieldArray } from "react-hook-form";
import Line from "../../../../../components/Line";
import { Orientation } from "../../../../../types";
import Pressable from "../../../../../components/Pressable";

type Props = {
  questionIndex: number;
  control: any;
  errors: any;
};

export default function MultipleChoicesOptions(props: Props) {
  const { questionIndex, control, errors } = props;

  const { fields, append, remove } = useFieldArray({
    control,
    name: `questions.${questionIndex}.choices`,
  });

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text size={16} weight="SemiBold" lightColor={Colors.nuetral_grey_700}>
          Choices
        </Text>
        <Pressable onPress={() => append({})}>
          <Feather name="plus" color={Colors.primary_500} size={24} />
        </Pressable>
      </View>
      <Line orientation={Orientation.Horizontal} />

      {fields.map((answer, index) => {
        return (
          <View key={answer.id} style={styles.fieldContainer}>
            <Text lightColor={Colors.nuetral_grey_700}>{index + 1} - </Text>
            <View style={{ flex: 1 }}>
              <Input
                placeholder="Option Text"
                label=""
                lightColor={Colors.tinted_grey_100}
                darkColor={Colors.nuetral_grey_700}
                control={control}
                errors={errors}
                name={`questions.${questionIndex}.choices.${index}.text`}
                required={true}
                errorMessage="Choice Text is required"
              />
            </View>
            <View>
              <Pressable onPress={() => remove(index)}>
                <Feather name="trash" color={Colors.primary_500} size={24} />
              </Pressable>
            </View>
          </View>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 12,
    gap: 8,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  fieldContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
});
